import { AppBar, Toolbar, Typography, Grid } from '@mui/material';
import comwareLogoWhite from '../../../../../assets/comwareWhite.png';
import interrogationLogo from '../../../../../assets/interrogationLogo.png';

export interface PropsHeaderSurveyLayout {
    title: string;
    description?: string;
    paragraph?: string;
    logo?: string;
    color?: string;
    fontFamily?: string;
}

export const HeaderSurveyLayout = ({
    title,
    description,
    paragraph,
    logo = comwareLogoWhite,
    color,
    fontFamily,
}: PropsHeaderSurveyLayout) => {
    return (
        <AppBar
            position="static"
            style={{
                marginBottom: '15vh',
                backgroundColor: color || '#3D91FF',
            }}
        >
            <Toolbar style={{ padding: '0 10%' }}>
                <Grid
                    zIndex={1}
                    width="100%"
                    height={{ xs: '20vh', lg: '30vh' }}
                    position="absolute"
                    bottom={{ xs: '-10vh', lg: '-15vh' }}
                    left={0}
                    bgcolor={color || '#3D91FF'}
                    style={{ borderRadius: '0 0 100% 100%' }}
                />
                <Grid
                    width={{ xs: '100%', lg: '50%' }}
                    minHeight="60vh"
                    zIndex={2}
                >
                    <Grid
                        textAlign={{ xs: 'center', lg: 'left' }}
                        display="flex"
                        flexDirection="column"
                        alignItems={{ xs: 'center', lg: 'start' }}
                    >
                        <Grid
                            mt="50px"
                            width={{
                                xs: '80%',
                                sm: '70%',
                                md: '50%',
                                lg: '60%',
                            }}
                        >
                            <img
                                src={logo ?? comwareLogoWhite}
                                alt="ComWare"
                                style={{
                                    width: '100%',
                                    height: 'auto',
                                    maxWidth: '100%',
                                    display: 'block',
                                }}
                            />
                        </Grid>
                        <Typography
                            my="10%"
                            variant="h4"
                            component="h1"
                            fontWeight="bold"
                            sx={{ color: '#fff', fontFamily: fontFamily || 'inherit' }}
                        >
                            {title}
                        </Typography>
                        <Typography
                            variant="h6"
                            component="h1"
                            mb={paragraph ? '20px' : 0}
                            sx={{ color: '#fff', fontFamily: fontFamily || 'inherit' }}
                        >
                            {description}
                        </Typography>
                        <Typography
                            variant="h6"
                            component="h1"
                            sx={{ color: '#fff', fontFamily: fontFamily || 'inherit' }}
                        >
                            {paragraph}
                        </Typography>
                    </Grid>
                </Grid>
                <Grid
                    zIndex={3}
                    mt="50px"
                    width="35%"
                    ml="15%"
                    textAlign="right"
                    display={{ xs: 'none', lg: 'block' }}
                >
                    <img src={interrogationLogo} alt="ComWare" width="100%" />
                </Grid>
            </Toolbar>
        </AppBar>
    );
};
